import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { addRxPlugin } from 'rxdb';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
import { service } from 'shared';
import { enableProdMode } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEn, 'en-US');
registerLocaleData(localePt, 'pt-BR');
registerLocaleData(localeEs, 'es-ES');

if (service.productionMode == service.Envirenment.production) {
  enableProdMode();
}

if (service.productionMode == service.Envirenment.development) {
  addRxPlugin(RxDBDevModePlugin);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
